module.exports = __webpack_public_path__ + "static/media/windows.5ab55e27.svg";